import React, { useState } from 'react'
import { makeStyles, useTheme, Typography, useMediaQuery, Container, TextField, Button, Divider, Grid,  Collapse } from '@material-ui/core';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        margin: "10px"
    },
    textField: {
        margin: "30px 0px 10px",
        width: "100%"
    }, fabButton: {
        [theme.breakpoints.up('md')]: {
        width: "70px",
        height: "70px",
        },
        margin: "8px",
        background: '#53f048'
    },
    nonRoundButtons: {
        margin: "5px",


    },
    definitionButton: {
        margin: "10px 0px 10px"
    },
    definitionText: {
        margin: "0px 0px 20px"
    },
    box: {
        border: "3px solid #c4c4c4",
        marginTop: "25px",
        padding: "20px 10px",
        marginBottom: "25px",
        textAlign: "center"
    },
    dividerThicker: {
        margin: "10px 0px 20px"
    },closeRow: {
        margin: '20px 0px'
    }


}));



const NotSureDialog = ({ handleDialogClose, wordToDisplay }) => {




    const theme = useTheme();
    const classes = useStyles();
    const isMdOrUp = useMediaQuery(theme.breakpoints.up("md"));
    const [openDefinition, setOpenDefinition] = useState(false);



    return (
        <Container >

            <Grid className={classes.closeRow} container justify="flex-end">
                <Grid item>
                    <Button onClick={() => handleDialogClose()} variant="outlined">
                        <CloseIcon />

                    </Button>
                </Grid>
            </Grid>

            <Container className={classes.box} >
                <Typography variant='h6' className={classes.sectionTitle}>{wordToDisplay.word}</Typography>
                <TextField className={classes.textField} id="type-in-guess-here" label="Type in guess here" multiline variant='outlined' rows={5} ></TextField>
                <Button className={classes.definitionButton} onClick={() => setOpenDefinition(!openDefinition)} variant="outlined">{openDefinition ? "Hide Definition" : "Show Definition"} </Button>
                <Divider className={classes.dividerThicker} />
                <Collapse in={openDefinition} timeout="auto" unmountOnExit>
                    <Typography variant="body2" className={classes.definitionText} >
                        {wordToDisplay.definition }
                    </Typography>
                <Divider className={classes.dividerThicker} />

                </Collapse>



                <Grid container justify="center" alignItems="center" >
                   

                    
                    <Grid item>
                        <Button onClick={() => handleDialogClose()} className={classes.nonRoundButtons} size={isMdOrUp ? "medium" : "small"} variant="contained" color="primary">
                            <KeyboardReturnIcon />
                        </Button>
                    </Grid>
                    

                </Grid>




            </Container>

        </Container>
    )
}

export default NotSureDialog
